import * as React from 'react'; 
import { connect } from 'react-redux';
import { fetchSellersFilter } from '../../actions/sellersActions'; 
import { setFiltroGrupoPlanes } from '../../actions/planesActions';
import { customStyle } from '../../template/CustomStyle';
import Select from 'react-select';


class FiltroGrupoPlanes extends React.Component{
    constructor (props){
        super(props); 
        this.estadoOptions = [
            { value: 0, label: 'VIGENTE' },
            { value: 2, label: 'DESHABILITADO' }
        ];
        this.state = {
            descripcion: this.props.filtro?.descripcion ?? "",
            numeroPagina: 1,
            cantidadPagina: 10,
            estado: this.estadoOptions.find(opt => opt.value === this.props.filtro?.estado) ?? null,
        }
    };

 
    myChangeHandler = async (e) =>{
        const { name, value } = e.target;
        this.setState({[name]: value});
        this.props.setFiltroGrupoPlanes({ ...this.props.filtro, [name]: value });
    }

    onSubmit = async (event) => {
        event.preventDefault();
        this.props.getPlanes();
    }
    
    selectSearchHandler = (option, config) => {
        this.setState({ [config.name]: option });
        this.props.setFiltroGrupoPlanes({ ...this.props.filtro, [config.name]: option ? option.value : null });
    }

    onSelectSearchInputSellers = (descripcion) => { 
        this.props.fetchSellersFilter({descripcion});
    }

    verTodos=()=>{
        this.setState({ descripcion: "", estado: null });
        this.props.setFiltroGrupoPlanes({ descripcion: "", estado: null, numeroPagina: 1, cantidadPagina: 10 });
        this.props.clearFilter();
    }

    render(){
        
        return ( 
            <div className="card card-body filter-card">
                <form className="row justify-content-start align-items-center form-material"
                    onSubmit={this.onSubmit}
                    onReset={this.verTodos}
                >

                    <div className="col-12 col-sm-3">
                        <label className="label-oscura">Descripción</label>
                        <input 
                            type="text" 
                            name="descripcion" 
                            value={this.state.descripcion} 
                            className="form-control" 
                            onChange={this.myChangeHandler} 
                        />
                    </div>
                    <div className="col-12 col-sm-3">
                        <label className="label-oscura">Estado</label>
                        <Select
                            name="estado"
                            options={this.estadoOptions}
                            onChange={this.selectSearchHandler}
                            value={this.state.estado}
                            styles={customStyle}
                        />
                    </div>

                    <div className="col-12 col-sm-auto mt-2">
                        <div className="row justify-content-center justify-content-end">
                            <button 
                                type="submit"
                                className="btn btn-sm btn-grey d-inline col-auto mx-3"
                            >
                                Buscar
                            </button>
                            <button 
                                type='reset'
                                className="btn btn-sm btn-grey d-inline col-auto"
                            >
                                Limpiar
                            </button>
                        </div>
                    </div>

                </form>
            </div>
        ); 
    }
}


const mapStateToProps = state => ({
    tipoUsuario: state.general.tipoUsuario,
    sellers: state.sellers.filteredSellers,
    filtro: state.planes.filtro
});

export default connect(mapStateToProps, {fetchSellersFilter, setFiltroGrupoPlanes}) (FiltroGrupoPlanes);